import { render, staticRenderFns } from "./SchoolLinkForm.vue?vue&type=template&id=6f0aac45&scoped=true"
import script from "./SchoolLinkForm.vue?vue&type=script&lang=js"
export * from "./SchoolLinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0aac45",
  null
  
)

export default component.exports